import React from 'react';
import CircadiaHalfWidthBarChart from '../../../../components/GraphBox/Components/CircadiaHalfWidthBarChart.tsx';
import CircadiaFullWidthBarChart from '../../../../components/GraphBox/Components/CircadiaFullWidthBarChart.tsx';
import { useSelector } from 'react-redux';
import { selectActiveFilters } from '../../../../redux/slices/filterSlice.ts';
import { useGetInvoiceDetailsGraphQuery } from '../../../../api/invoice.api.ts';
import { INVOICE_DETAILS_CHART } from '../../../../constants/messages.tsx';
import { selectAccount } from '../../../../redux/slices/accountSlice.ts';

interface InvoiceDetailsChartProps {
	registerExportFn?: (exportFn: () => void) => void;
	fullWidth?: boolean;
}

const InvoiceDetailsChart: React.FC<InvoiceDetailsChartProps> = ({
	registerExportFn,
	fullWidth = false,
}) => {
	const account = useSelector(selectAccount);

	const activeFilters = useSelector(selectActiveFilters);

	const {
		data: invoiceDetailsData = {
			invoicePastDue: [],
		},
	} = useGetInvoiceDetailsGraphQuery(
		{
			accountId: account.accountId,
			sourceId: account.sourceId,
			accountTypeCode: account.accountTypeCode,
			filters: activeFilters,
		},
		{ skip: !account || !account.accountId }
	);

	const chartProps = {
		title: INVOICE_DETAILS_CHART,
		xaxislabel: 'Invoice Past Due',
		yaxislabel: 'Invoice Balance',
		data: invoiceDetailsData.invoicePastDue,
		registerExportFn,
		currency: true,
	};

	return fullWidth ? (
		<CircadiaFullWidthBarChart {...chartProps} />
	) : (
		<CircadiaHalfWidthBarChart {...chartProps} />
	);
};

export default InvoiceDetailsChart;
